var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPoint(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2Z",
    fill: "#0A0400"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 7H12.1914L12.5076 7.00604C12.9237 7.02215 13.3173 7.07048 13.6886 7.15103C14.1526 7.25172 14.5553 7.42026 14.8968 7.65666C15.2383 7.89306 15.5075 8.20606 15.7045 8.59568C15.9015 8.98531 16 9.46904 16 10.0469C16 10.5985 15.9015 11.0779 15.7045 11.485C15.5075 11.8921 15.2405 12.227 14.9034 12.4897C14.5663 12.7523 14.1701 12.9472 13.7148 13.0741C13.2595 13.2011 12.7692 13.2645 12.2439 13.2645H10.9437V15.7467L10.9372 15.8601C10.881 16.3434 10.4703 16.7186 9.97186 16.7186C9.43512 16.7186 9 16.2835 9 15.7467V8L9.00673 7.88338C9.06449 7.38604 9.48716 7 10 7ZM13.5769 8.86492C13.2311 8.64603 12.7211 8.53658 12.0469 8.53658H10.9437V11.728H12.1126L12.3059 11.7238C13.4991 11.6705 14.0957 11.1116 14.0957 10.0469C14.0957 9.4778 13.9228 9.0838 13.5769 8.86492Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoint);
export default __webpack_public_path__ + "static/media/point.dda113d618b38579c9778b183167b302.svg";
export { ForwardRef as ReactComponent };